import React from "react";
import styles from "./CaseFiles.module.scss";

export const MenuList = ({ imageSrc, name, onClick, border, icon, index }) => (
  <div className={styles["list-item"]} role="button">
    <div
      role="button"
      onClick={onClick}
      className=" ps-3 flex align-items-center  pe-0"
      style={{
        padding: index === 1 ? "0px 0px 10px 0px" : "10px 0px 10px 0px",
      }}
    >
      {icon ? (
        <div
          role="button"
          style={{
            marginRight: "10px",
          }}
        >
          {icon}
        </div>
      ) : (
        <img
          role="button"
          src={imageSrc}
          alt="Icons"
          style={{ marginRight: "15px" }}
        />
      )}
      <div role="button" className={`${styles.list}`}>
        {name}
      </div>
    </div>
    {border && <div className={`${styles["border-bottom"]}`}></div>}
  </div>
);
